<template>
  <div class="ticketcollector-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :xs="24" :sm="12">
        <Button @click="showModel()" type="success" class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="create('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="姓名">
          <Input v-model="dataInfo.name" placeholder="请输入姓名..."></Input>
        </FormItem>
        <FormItem label="电话" prop="phone">
          <Input v-model="dataInfo.phone" placeholder="请输入电话..."></Input>
        </FormItem>
        <FormItem label="密码">
          <Input v-model="dataInfo.password" type="password" placeholder="输入密码..."></Input>
        </FormItem>
        <FormItem label="确认密码">
          <Input v-model="dataInfo.password_confirmation" type="password" placeholder="确认密码..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal
      v-model="showEditModalStatus"
      :title="title"
      @on-ok="update('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="姓名">
          <Input v-model="dataInfo.name" placeholder="请输入姓名..."></Input>
        </FormItem>
        <FormItem label="电话" prop="phone">
          <Input v-model="dataInfo.phone" placeholder="请输入电话..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改密码 -->
    <Modal v-model="showEditPwdStatus" title="修改密码" @on-ok="updatePassword()" :loading="loading">
      <Form :model="adminPwd" action="javascript:void(0)">
        <FormItem label="密码" prop="password">
          <Input v-model="adminPwd.password" type="password" placeholder="输入密码..."></Input>
        </FormItem>
        <FormItem label="确认密码" prop="password_confirmation">
          <Input v-model="adminPwd.password_confirmation" type="password" placeholder="确认密码..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ticketcollector-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 50
        },
        {
          title: "名称",
          key: "name",
          minWidth: 50
        },
        {
          title: "电话",
          key: "phone",
          minWidth: 50
        },
        {
          title: "操作",
          key: "action",
          width: 600,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showEditPwd(params.row.id);
                    }
                  }
                },
                "改密"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      adminPwd: {
        password: "",
        password_confirmation: ""
      },
      dataInfo: {
        name: "",
        phone: "",
        password: "",
        password_confirmation: ""
      },
      showModalStatus: false,
      showEditModalStatus: false,
      showEditPwdStatus: false,
      dataInfoValidate: {
        phone: [{ required: true, message: "电话必须填写", trigger: "blur" }]
      }
    };
  },
  // 组件
  components: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.ticketcollector
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        name: "",
        phone: "",
        password: "",
        password_confirmation: ""
      };
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.dataInfo = {
        name: "",
        phone: "",
        password: "",
        password_confirmation: ""
      };
      this.showEditModalStatus = !this.showEditModalStatus;
      this.$api.ticketcollector.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
      });
    },
    // 添加
    create(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.dataInfo.password != this.dataInfo.password_confirmation) {
            this.$Message.error("两次密码不一致");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          this.$api.ticketcollector.create(this.dataInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 修改
    update(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.ticketcollector.edit(this.dataInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showEditModalStatus = !this.showEditModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 展开修改密码
    showEditPwd(value) {
      this.id = value;
      this.adminPwd.password = "";
      this.adminPwd.password_confirmation = "";
      this.showEditPwdStatus = !this.showEditPwdStatus;
    },
    // 修改密码
    updatePassword: function() {
      if (this.adminPwd.password != this.adminPwd.password_confirmation) {
        this.$Message.error("两次密码不一致");
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
        return;
      }
      this.$api.ticketcollector
        .editpwd({
          id: this.id,
          password: this.adminPwd.password,
          password_confirmation: this.adminPwd.password_confirmation
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showEditPwdStatus = !this.showEditPwdStatus;
        });
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.ticketcollector.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.ticketcollector.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
</style>